// extracted by mini-css-extract-plugin
module.exports = {"Buttons":"SaveSearch_Buttons__2ov1L","SaveSearch":"SaveSearch_SaveSearch__1okjm"};